"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackSDK = void 0;
var tslib_1 = require("tslib");
var axios_1 = require("../utils/axios");
var jwt_handler_1 = require("../utils/jwt-handler");
var location_handler_1 = require("../utils/location-handler");
var FeedbackSDK = (function () {
    function FeedbackSDK() {
        var _this = this;
        this.getGenericSurvey = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var res, _a, _b, _c;
            var _d, _e, _f;
            return tslib_1.__generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _b = (_a = axios_1.axios).get;
                        _c = ["".concat(this.baseApi, "/feedback/surveys/generic-feedback")];
                        return [4, jwt_handler_1.JWTHandler.getAxiosConfig()];
                    case 1: return [4, _b.apply(_a, _c.concat([_g.sent()]))];
                    case 2:
                        res = _g.sent();
                        return [2, (_f = (_e = (_d = res.data) === null || _d === void 0 ? void 0 : _d.result) === null || _e === void 0 ? void 0 : _e.surveyId) !== null && _f !== void 0 ? _f : ''];
                }
            });
        }); };
        this.getSuggestionSurvey = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var res, _a, _b, _c;
            var _d, _e, _f;
            return tslib_1.__generator(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        _b = (_a = axios_1.axios).get;
                        _c = ["".concat(this.baseApi, "/feedback/surveys/suggestion-feedback")];
                        return [4, jwt_handler_1.JWTHandler.getAxiosConfig()];
                    case 1: return [4, _b.apply(_a, _c.concat([_g.sent()]))];
                    case 2:
                        res = _g.sent();
                        return [2, (_f = (_e = (_d = res.data) === null || _d === void 0 ? void 0 : _d.result) === null || _e === void 0 ? void 0 : _e.surveyId) !== null && _f !== void 0 ? _f : ''];
                }
            });
        }); };
        this.getSurveyId = function (targetEvent) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var res, _a, _b, _c, e_1;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 3, , 4]);
                        _b = (_a = axios_1.axios).get;
                        _c = ["".concat(this.baseApi, "/feedback/surveys?target-event=").concat(targetEvent)];
                        return [4, jwt_handler_1.JWTHandler.getAxiosConfig()];
                    case 1: return [4, _b.apply(_a, _c.concat([_d.sent()]))];
                    case 2:
                        res = _d.sent();
                        return [2, res.data.result.surveyId];
                    case 3:
                        e_1 = _d.sent();
                        console.error(e_1);
                        return [2, null];
                    case 4: return [2];
                }
            });
        }); };
        this.postEventOfInterest = function (eventOfInterest) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, _b, _c;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _b = (_a = axios_1.axios).post;
                        _c = ["".concat(this.baseApi, "/feedback/event-of-interest"), { eventOfInterest: eventOfInterest }];
                        return [4, jwt_handler_1.JWTHandler.getAxiosConfig()];
                    case 1: return [4, _b.apply(_a, _c.concat([_d.sent()]))];
                    case 2:
                        _d.sent();
                        return [2];
                }
            });
        }); };
        this.collectSurveyInteraction = function (type) {
            return function (surveyId, _questionId, _answer) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var _a, _b, _c, e_2;
                return tslib_1.__generator(this, function (_d) {
                    switch (_d.label) {
                        case 0:
                            _d.trys.push([0, 3, , 4]);
                            _b = (_a = axios_1.axios).post;
                            _c = ["".concat(this.baseApi, "/feedback/survey-interactions"), {
                                    action: type,
                                    surveyId: surveyId,
                                }];
                            return [4, jwt_handler_1.JWTHandler.getAxiosConfig()];
                        case 1: return [4, _b.apply(_a, _c.concat([_d.sent()]))];
                        case 2:
                            _d.sent();
                            return [3, 4];
                        case 3:
                            e_2 = _d.sent();
                            console.error(e_2);
                            return [3, 4];
                        case 4: return [2];
                    }
                });
            }); };
        };
        this.baseApi = (0, location_handler_1.getCurrentEnvBaseApi)({
            prefixUri: '/rsp-api/api/v2',
        });
    }
    FeedbackSDK.setEventOfInterestJWTCookie = function (cookie) {
        jwt_handler_1.JWTHandler.setCookie('eventOfInterest', cookie, {
            expires: 'session',
            path: '/',
            domain: window.location.hostname.split('.').slice(1).join('.'),
        });
    };
    return FeedbackSDK;
}());
exports.FeedbackSDK = FeedbackSDK;
//# sourceMappingURL=base.js.map